import {
  ClassOption,
  classDefaultOption,
  CodingOption,
  codingDefaultOption,
  CohortOption,
  cohortDefaultOption,
  DaysOption,
  FacilityOption,
  filterDefaultOption,
  SearchOption,
  StatusOption,
  statusDefaultOption,
  TocQueryState,
  TocSortState,
  TypeOption,
  typeDefaultOption,
} from "./filters";

export type TocFilterState = {
  searchText: string;
  appliedSearch: SearchOption | undefined;
  facility: FacilityOption | undefined;
  cohort: CohortOption;
  type: TypeOption;
  days: DaysOption;
  coding: CodingOption;
  status: StatusOption;
  class: ClassOption;
  sort: TocSortState | undefined;
};

export type TocFilterAction =
  | { type: "setSearchText"; value: string }
  | { type: "applySearch" }
  | { type: "setFacility"; value: FacilityOption | undefined }
  | { type: "setCohort"; value: CohortOption }
  | { type: "setType"; value: TypeOption }
  | { type: "setDays"; value: DaysOption }
  | { type: "setCoding"; value: CodingOption }
  | { type: "setStatus"; value: StatusOption }
  | { type: "setClass"; value: ClassOption }
  | { type: "setSort"; value: TocSortState | undefined }
  | { type: "syncTypeFromSort"; value: TypeOption }
  | { type: "clearFilters" };

export function tocFilterReducer(state: TocFilterState, action: TocFilterAction): TocFilterState {
  switch (action.type) {
    case "setSearchText":
      return { ...state, searchText: action.value };
    case "applySearch":
      return { ...state, appliedSearch: state.searchText.trim() || undefined };
    case "setFacility":
      return { ...state, facility: action.value };
    case "setCohort":
      return { ...state, cohort: action.value };
    case "setType":
      return { ...state, type: action.value };
    case "setDays":
      return { ...state, days: action.value };
    case "setCoding":
      return { ...state, coding: action.value };
    case "setStatus":
      return { ...state, status: action.value };
    case "setClass":
      return { ...state, class: action.value };
    case "setSort":
      return { ...state, sort: action.value };
    case "syncTypeFromSort":
      return { ...state, type: action.value };
    case "clearFilters":
      return {
        ...state,
        facility: undefined,
        cohort: cohortDefaultOption,
        type: typeDefaultOption,
        days: filterDefaultOption,
        coding: codingDefaultOption,
        status: statusDefaultOption,
        class: classDefaultOption,
        searchText: "",
        appliedSearch: undefined,
        sort: undefined,
      };
  }
}

export function buildInitialFilterState(initialQueryState?: TocQueryState): TocFilterState {
  return {
    searchText: initialQueryState?.search ?? "",
    appliedSearch: initialQueryState?.search,
    facility: initialQueryState?.facility,
    cohort: initialQueryState?.cohort ?? cohortDefaultOption,
    type:
      initialQueryState?.type ??
      (initialQueryState?.sortBy === "dischargeTime" ? "Discharged" : typeDefaultOption),
    days: initialQueryState?.days ?? filterDefaultOption,
    coding: initialQueryState?.coding ?? codingDefaultOption,
    status: initialQueryState?.status ?? statusDefaultOption,
    class: initialQueryState?.class ?? classDefaultOption,
    sort:
      initialQueryState?.sortBy && initialQueryState.sortDir
        ? { sortBy: initialQueryState.sortBy, sortDir: initialQueryState.sortDir }
        : undefined,
  };
}
